import { Dispatch, Fragment, SetStateAction } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { RiArrowDropDownLine } from 'react-icons/ri';

import { OptionsType } from '../../../types/content';

/* eslint-disable-next-line */
type DropdownTabProps = {
  dropdownWidthMobile?: string;
  options: OptionsType[];
  value: OptionsType;
  setTab: Dispatch<SetStateAction<OptionsType>>;
};

export function DropdownTab(props: DropdownTabProps) {
  const { dropdownWidthMobile = 'w-full', options, value, setTab } = props;

  function handleClickOption(tab: string, value: string) {
    setTab({ tab, value });
  }

  const optionTabs = options.map((option) => (
    <Menu.Item key={option.tab}>
      <div
        className="px-2 py-px hover:bg-white text-subtitle text-ellipsis overflow-hidden"
        onClick={() => handleClickOption(option.tab, option.value)}
      >
        {option.tab}
      </div>
    </Menu.Item>
  ));

  return (
    <Menu as="div" className="relative inline-block">
      <Menu.Button
        className={`${dropdownWidthMobile} sm:w-52 max-w-52 shadow-sm p-2 bg-headerBackground border border-zinc-400 text-left text-davysGray font-MuseoSans100 text-subtitle flex items-center`}
      >
        {value.tab}
        <RiArrowDropDownLine className="text-header6 ml-auto" />
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="origin-top-right z-50 absolute mt-2 shadow-lg bg-headerBackground border border-zinc-400 text-left text-zinc-400 ring-1 ring-black font-MuseoSans100 w-full ring-opacity-5 focus:outline-none max-h-72 overflow-y-auto">
          {optionTabs}
        </Menu.Items>
      </Transition>
    </Menu>
  );
}

export default DropdownTab;
